import { render, staticRenderFns } from "./TransferEdit.vue?vue&type=template&id=48db80fa&scoped=true&"
import script from "./TransferEdit.vue?vue&type=script&lang=js&"
export * from "./TransferEdit.vue?vue&type=script&lang=js&"
import style0 from "./TransferEdit.vue?vue&type=style&index=0&id=48db80fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48db80fa",
  null
  
)

export default component.exports